import React from 'react';
import classNames from 'classnames';
import { instanceOf, string } from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Heading } from '@thd-olt-component-react/heading';
import { WriteAReview } from '../WriteAReview/WriteAReview.component';
import { usePresentation } from '../../context/PresentationProvider';
import './FirstReview.style.scss';

export const FirstReview = ({
  apiKey,
  className,
  itemId,
  reviewStatistics
}) => {
  const CONTACT_US_LINK = 'https://www.homedepot.com/c/customer_service';
  const { useCondensedLayout } = usePresentation();
  const textClasses = classNames({
    'first-review__text--tight': useCondensedLayout
  });
  const headerClasses = classNames({
    'first-review__mobile-text': useCondensedLayout
  });
  return (
    <div className="first-review">
      <Row>
        <Col flatten>
          <Heading title="Customer Reviews" className={headerClasses} underline />
        </Col>
        <Col xs="12" className={textClasses}>
          Do you own this product? Be the first to rate it.
          Your feedback will help users like you to make informed decisions
          and will help us to improve our product offerings!
        </Col>
      </Row>
      <Row>
        <Col xs="12">
          {reviewStatistics
          && (
            <WriteAReview
              apiKey={apiKey}
              className={className}
              itemId={itemId}
              reviewStatistics={reviewStatistics}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col xs="12" className={textClasses}>
          <span>
            If you have questions or comments
            regarding the customer service you received
            please <a className="first-review__contact-us" href={CONTACT_US_LINK}>contact us.</a>
          </span>
        </Col>
      </Row>
    </div>
  );
};

FirstReview.displayName = 'FirstReview';

FirstReview.propTypes = {
  apiKey: string.isRequired,
  reviewStats: instanceOf(Object),
  itemId: string.isRequired,
  className: string
};

FirstReview.defaultProps = {
  reviewStatistics: null,
  className: null
};
